import * as _ from "lodash";
import * as angular from "angular";

export class DialogUtils {
    private readonly $mdDialog: any;
    private readonly $rootScope: any;
    private readonly defaultOptions = {
        fullscreen: true,
        multiple: true,
        size: "med",
        backdropBlur: false, // Add default backdropBlur option
    };
    private readonly defaultDeleteOptions = {
        component: "vc-general-info",
        fullscreen: false,
        multiple: false,
        clickOutsideToClose: true,
        backdropBlur: false, // Add to delete options too
        locals: {
            title: "Delete?",
            bodyText: "They will be permanently deleted",
        },
    };
    constructor($mdDialog: any, $rootScope: any) {
        this.$mdDialog = $mdDialog;
        this.$rootScope = $rootScope;
    }

    show(params: any): any {
        const defaultParams = _.cloneDeep(this.defaultOptions);
        if (params.component) {
            let paramsString = "";

            angular.forEach(params.locals, (param: any, paramName: string) => {
                const hypenatedParamName = paramName.replace(
                    /[A-Z]/g,
                    (m) => "-" + m.toLowerCase()
                );
                paramsString +=
                    typeof param === "function" && param.originalFn
                        ? // generate function binding
                          hypenatedParamName +
                          "='" +
                          paramName +
                          String(param.originalFn).substring(
                              String(param.originalFn).indexOf("("),
                              String(param.originalFn).indexOf(")") + 1
                          ) +
                          "' "
                        : hypenatedParamName + "='" + paramName + "' ";
            });

            params.template =
                "<" +
                params.component +
                " layout='column' flex " +
                paramsString +
                "></" +
                params.component +
                ">";
        }

        if (params.scope) {
            params.scope = angular.extend(
                params.scope.$new(true),
                params.locals
            );
        } else if (params.locals) {
            params.scope = angular.extend(
                this.$rootScope.$new(true),
                params.locals
            );
        }
        params = angular.extend(defaultParams, params);

        const ariaLabel = params.ariaLabel
            ? ' aria-label="' + params.ariaLabel + '" '
            : " aria-label='Dialog'";

        const flex = this.getSize(params.size);

        const style = params.style ? " style='" + params.style + "' " : "";

        let dialogClass = params.class ? " class='" + params.class : " class='";

        const id = params.id ? " id='" + params.id + "' " : "";

        const ngClass = params.ngClass
            ? ' ng-class="' + params.ngClass + '" '
            : "";

        if (params.forceFullscreen) {
            dialogClass += " force-fullscreen";
        }

        dialogClass += "'";

        params.template =
            "<md-dialog md-theme='navbar' layout='column' " +
            id +
            ariaLabel +
            dialogClass +
            ngClass +
            flex +
            style +
            ">" +
            params.template +
            "</md-dialog>";

        if (params.backdropBlur) {
            params.onShowing = (scope: any, element: any) => {
                this.$rootScope.$evalAsync(() => {
                    const containers = document.querySelectorAll(
                        ".md-dialog-container"
                    );
                    containers.forEach((container) => {
                        container.classList.add("blurred-backdrop");
                    });
                });
            };
        }

        return this.$mdDialog.show(params);
    }

    showPreConfiguredDialog(dialog: object): any {
        return this.$mdDialog.show(dialog);
    }

    confirm(): any {
        return this.$mdDialog.confirm();
    }

    hide(params?: any): void {
        this.$mdDialog.hide(params);
    }

    cancel(params?: object): void {
        this.$mdDialog.cancel(params);
    }

    delete(params: any): any {
        const defaultDeleteParams = _.cloneDeep(this.defaultDeleteOptions);
        params = _.merge(defaultDeleteParams, params);
        params.ariaLabel = params.locals.title;
        return this.show(params);
    }

    alert(): any {
        return this.$mdDialog.alert();
    }

    prompt(): any {
        return this.$mdDialog.prompt();
    }

    getSize(paramsSize?: string): string {
        switch (paramsSize) {
            case "small":
                return " flex='20' flex-lg='25' flex-md='40' flex-sm='60' flex-xs='90' ";
            case "med":
                return " flex='30' flex-lg='35' flex-md='60' flex-sm='80' flex-xs='95' ";
            case "large":
                return " flex='40' flex-lg='50' flex-md='65' flex-sm='90' flex-xs='95' ";
            case "large-plus":
                return " flex='45' flex-lg='60' flex-md='65' flex-sm='90' flex-xs='95' ";
            case "x-large":
                return " flex='50' flex-lg='80' flex-md='90' flex-sm='95' flex-xs='95' ";
            case "xx-large":
                return " flex='100' flex-lg='100' flex-md='100' flex-sm='100' flex-xs='100' ";
            case "auto":
                return " ";
            default:
                return "";
        }
    }
}

angular.module("vcHelper").service("DialogUtils", DialogUtils);
